import { combineReducers } from "redux";

import workkardDetail from "./workkardDetailInfo";
import panelVisibility from "./panelVisibility";
import createNote from "./createNote";
import attachedWorkkardFiles from "./attachedWorkkardFiles";
import attachedWorkkardLetters from './attachedWorkkardLetters';
import closeActivity from "./closeActivity";
import closeWorkkard from "./closeWorkkard";
import startTour from "./startTour";
import combinedView from "./combinedView";
import resolution from './resolution';
import buttonLoaders from './buttonLoaders';
import detailPage from './detailPage';
import workkardDetailSliceReducer from '../slice';

const legacyReducer = combineReducers({
  workkardDetail,
  panelVisibility,
  createNote,
  combinedView,
  attachedWorkkardFiles,
  attachedWorkkardLetters,
  closeActivity,
  closeWorkkard,
  startTour,
  resolution,
  buttonLoaders,
  detailPage,
});

const SLICE_OWNED_KEYS = [
  'associatedWorkkard',
  'associatedWorkkardFilter',
  'contactInsured',
  'activityListing',
  'activityDetail',
  'createActivity',
  'reOpenReasonList',
  'middlePanel',
];

export default function workkardDetailRootReducer(state, action) {
  let legacyState = state;
  let prevSliceState;
  if (state) {
    legacyState = {};
    prevSliceState = {};
    for (const key of Object.keys(state)) {
      if (SLICE_OWNED_KEYS.includes(key)) {
        prevSliceState[key] = state[key];
      } else {
        legacyState[key] = state[key];
      }
    }
  }

  const nextLegacyState = legacyReducer(legacyState, action);
  const nextSliceState = workkardDetailSliceReducer(prevSliceState, action);

  if (state && nextLegacyState === legacyState && nextSliceState === prevSliceState) {
    return state;
  }
  return { ...nextLegacyState, ...nextSliceState };
}
